import moment from 'moment';
import 'moment-timezone';
import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { timezones } from '../utils/variables';


class SeminarTable extends Component {
  render() {
    const SeminarTable = props => {
      return (
        <tbody>
          {props.items.map(item => (
            <SeminarTableItem
              key={item.id}
              item={item}
              handleViewClick={this.handleViewClick}
            />))
          }
        </tbody>
      );
    };


    const SeminarTableHeader = props => {
      return (
        <thead className='dark'>
          <tr>
            <th>Region</th>
            <th>Location</th>
            <th>When</th>
            <th>Registrations</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
      )
    }
    const SeminarTableItem = props => {
      return (
        <tr key={props.index}>
          <td>{props.item.region}</td>
          <td>
            <Link to={`/m1/seminars/${props.item.id}/registrations/all`}>{props.item.location}</Link>
          </td>
          <td>
            {moment(props.item.at).tz(timezones[props.item.region || 'VIC']).format("MMM Do YYYY h:mm a")}
          </td>
          <td>{props.item.registrations} / {props.item.capacity}</td>
          <td>{props.item.status}</td>
          <td><Link to={`/m1/seminars/${props.item.id}/edit`}>edit</Link></td>
        </tr>
      );
    };
    return (
      <div>
        {this.props.items.length === 0
          ? <div>No matching seminars</div>
          : <table className="table table-hover table-bordered responsive">
            <SeminarTableHeader />
            <SeminarTable items={this.props.items} />
          </table>
        }
      </div>
    );
  }
}

export default SeminarTable;
